import type { VerificationProfileSettingsModel } from '@models';
import {
    DocsVerificationBiometricTypeEnum,
    DocsVerificationDocumentTypeEnum,
    DocsVerificationPhotosKeysEnum,
} from '@models/enums';
import type { GetVerificationResponse } from '@modules/docs-verification-widget/models/get-verification-response';
import dayjs from 'dayjs';

export const VERIFICATION_RESPONSE: GetVerificationResponse = {
    id: 'VD485833FBBBFEFCA',
    status: 'active',
    checks: {
        poa: {
            status: 'pending',
            errors: [],
            pending_documents: [DocsVerificationPhotosKeysEnum.POA],
            data: null,
        },
        liveness: {
            status: 'pending',
            errors: [],
            pending_documents: [DocsVerificationPhotosKeysEnum.LIVENESS_PHOTO],
            data: null,
        },
        document_mrz: {
            status: 'pending',
            errors: [],
            pending_documents: [
                DocsVerificationPhotosKeysEnum.RESIDENCE_PERMIT_FRONT,
                DocsVerificationPhotosKeysEnum.RESIDENCE_PERMIT_BACK,
                DocsVerificationPhotosKeysEnum.ID_CARD_BACK,
                DocsVerificationPhotosKeysEnum.PASSPORT,
                DocsVerificationPhotosKeysEnum.ID_CARD_FRONT,
            ],
            data: null,
        },
        face_comparison: {
            status: 'pending',
            errors: [],
            pending_documents: [
                DocsVerificationPhotosKeysEnum.SELFIE,
                DocsVerificationPhotosKeysEnum.RESIDENCE_PERMIT_FRONT,
                DocsVerificationPhotosKeysEnum.PASSPORT,
                DocsVerificationPhotosKeysEnum.LIVENESS_PHOTO,
                DocsVerificationPhotosKeysEnum.ID_CARD_FRONT,
            ],
            data: null,
        },
    },
    settings: {
        poi_required: true,
        poi_allowed_documents: [
            DocsVerificationDocumentTypeEnum.PASSPORT,
            DocsVerificationDocumentTypeEnum.ID_CARD,
            DocsVerificationDocumentTypeEnum.RESIDENCE_PERMIT,
        ],
        face_comparison_required: true,
        face_comparison_allowed_documents: [DocsVerificationBiometricTypeEnum.LIVENESS_PHOTO],
        poa_required: true,
        poa_allowed_documents: [],
        countries: [],
        allow_poi_manual_uploads: true,
        allow_desktop: true,
    } as unknown as VerificationProfileSettingsModel,
    expires_at: dayjs().add(360, 'minutes').toDate().toString(),
    verification_url: 'https://am.dataspike.io/VD485833FBBBFEFCA',
};
